import React from "react";
import { Link } from "react-router-dom";
import classes from "./footer.module.css";
import Tooltip from "./socialmedia";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      <div className={classes.footerContainer}>
        <div className={classes.footerSection}>
          <div className={classes.logoSection}>
            <h2 className={classes.logoText}>Artist Next Door</h2>
            <p className={classes.tagline}>
              Discover talent right around the corner
            </p>
          </div>
          <Tooltip />
        </div>

        <div className={classes.footerGrid}>
          <div className={classes.footerCol}>
            <h3>Pages</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/about-us">About</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact</Link>
              </li>
              <li>
                <Link to="/login">Register</Link>
              </li>
              <li>
                <Link to="/artist-next-door-arena">Artist Next Door Arena</Link>
              </li>
            </ul>
          </div>

          <div className={classes.footerCol}>
            <h3>Categories</h3>
            <ul>
              <li>
                <Link to="/categories/singer">Singer</Link>
              </li>
              <li>
                <Link to="/categories/dancer">Dancer</Link>
              </li>
              <li>
                <Link to="/categories/comedian">Comedian</Link>
              </li>
              <li>
                <Link to="/categories/musician">Musician</Link>
              </li>
              <li>
                <Link to="/categories/magician">Magician</Link>
              </li>
              <li>
                <Link to="/categories/music-band">Music Band</Link>
              </li>
            </ul>
          </div>

          <div className={classes.footerCol}>
            <h3>More Categories</h3>
            <ul>
              <li>
                <Link to="/categories/dance-group">Dance Group</Link>
              </li>
              <li>
                <Link to="/categories/dj">DJ</Link>
              </li>
              <li>
                <Link to="/categories/rapper">Rapper</Link>
              </li>
              <li>
                <Link to="/categories/beat-boxer">Beat Boxer</Link>
              </li>
              <li>
                <Link to="/categories/video-editor">Video Editor</Link>
              </li>
              <li>
                <Link to="/categories/speaker">Speaker</Link>
              </li>
            </ul>
          </div>

          <div className={classes.footerCol}>
            <h3>Legal</h3>
            <ul>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/refund-policy">Refund Policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">Terms And Conditions</Link>
              </li>
              <li>
                <Link to="/shipping-policy">Shipping Policy</Link>
              </li>
              <li>
                <Link to="/user-policy">User Account Policy</Link>
              </li>
            </ul>

            <div className={classes.newsletter}>
              <h3>Newsletter</h3>
              <p>Stay updated with the latest artists and events</p>
              <form className={classes.subscribeForm}>
                <input type="email" placeholder="Your email" required />
                <button type="submit">Subscribe</button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.footerBottom}>
        <p>&copy; {currentYear} Artist Next Door. All rights reserved.</p>
        <p>
          Designed with <span className={classes.heart}>♥</span> by Spicin for
          artists everywhere
        </p>
      </div>
    </footer>
  );
};

export default Footer;
